export default window.searchApp;
